<template>
  <PageSection
    v-if="editionMode || (checkBoxValue && model.length > 0)"
    disable-sticky-margin
    :title="label"
  >
    <div class="flex flex-col gap-4">
      <label
        v-if="editionMode"
        class="flex cursor-pointer items-center gap-2 font-semibold"
        :for="`checkbox-${label}`"
      >
        <input
          :id="`checkbox-${label}`"
          class="form-check-input"
          type="checkbox"
          :checked="checkBoxValue"
          @change="onCheckBoxChange($event.target.checked)"
        />
        <span class="capitalize-first">{{ $t('button.activate') }}</span>
      </label>

      <template v-if="checkBoxValue">
        <div class="grid grid-cols-1 gap-4 xl:grid-cols-2">
          <TaskQuestionCardComponent
            v-for="(question, index) in model"
            :key="index"
            class="overflow-auto"
            :editionMode="editionMode"
            :questionIndex="index"
            :question="question"
            :permission="permission"
            :errors-form-start="errorsFormStart"
            :errors-form-end="errorsFormEnd"
            :errors-option-start="errorsOptionStart"
            :errors-option-end="errorsOptionEnd"
            @deleteButton="deleteQuestion"
          />
        </div>
        <div v-if="editionMode" class="flex justify-end">
          <BaseButton
            icon="plus"
            color="dark"
            :title="$t('button.add_new_f', { var: $t('global.question') })"
            @click="addQuestion('starting_form')"
          />
        </div>
      </template>
    </div>
  </PageSection>
</template>

<script>
import { mapMutations } from 'vuex'

import TaskQuestionCardComponent from './TaskQuestionCardComponent'

export default {
  name: 'TaskQuestionComponent',
  components: { TaskQuestionCardComponent },
  props: {
    label: {
      type: String,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    checkBoxValue: {
      type: Boolean,
      required: true
    },
    permission: {
      type: Object,
      required: true
    },
    editionMode: {
      type: Boolean,
      required: true
    },
    errorsFormStart: {
      type: Boolean,
      required: false,
      default: false
    },
    errorsFormEnd: {
      type: Boolean,
      required: false,
      default: false
    },
    errorsOptionStart: {
      type: Boolean,
      required: false,
      default: false
    },
    errorsOptionEnd: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    ...mapMutations({ alterTask: 'task/alterTask' }),
    addQuestion() {
      this.model.push({
        type: null,
        question: null,
        options: [],
        value: ''
      })
    },
    onCheckBoxChange(newValue) {
      const attribute =
        this.label === this.$t('attributes.start_task_survey')
          ? 'form_on_start'
          : 'form_on_end'
      this.alterTask({ attribute, value: newValue })
    },
    deleteQuestion(questionIndex) {
      this.model.splice(questionIndex, 1)
    }
  },
  watch: {}
}
</script>
